import { mapState, mapGetters, mapActions } from 'vuex';
//import $ from 'jquery';
import Swal from 'sweetalert2';

import SharedHeader from '@/components/SharedHeader.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Spinner from '@/components/Spinner.vue';
import PassportImg from '@handl-web/pz-ui/img/passport.jpg';
//import { SETTING_PAGE } from '@/constants/routes';
import { getIsIosSafari } from '@/utils/browser';
import { swalSuccess } from '@/utils/swal2';
import { LOADING_MESSAGE } from './Identity.constants';

export default {
  name: 'Identity',
  components: {
    SharedHeader,
    Footer,
    Aside,
    Spinner,
    WayFindBar,
  },

  data: () => {
    return {
      isForeigner: false,

      loadingMessage: LOADING_MESSAGE,

      username: '',
      isShowUsernameBlank: false,
      passportNo: '',
      isShowPassportNoBlank: false,

      //file: null,
      passportSrc: PassportImg,
      //flagInvalid: {
      //  username: false,
      //  passportNo: false,
      //  file: false,
      //},
      isPassportNofile: true,
      isShowPassportNofile: false,
      isPassportTooLarge: false,
      //isIdentifyReady: false,
      //
      isIosSafari: getIsIosSafari(),
    };
  },

  computed: {
    ...mapGetters({
      immLoading: 'immLoading',
      mg_userInfo: 'userInfo',
      mg_identificationStatus: 'identificationStatus',
    }),

    ...mapState('Identity', {
      //ms_res_certificate: 'res_certificate',
      ms_res_identificationconfig: 'res_identificationconfig',
      ms_res_idcheckandsave: 'res_idcheckandsave',
      //ms_res_idrefuse: 'res_idrefuse',
      //ms_res_idrecall: 'res_idrecall',
      ms_isRequest: 'isRequest',
    }),

    c_inputReadOnly() {
      //return this.mg_userInfo.authenticated !== -1;
      //0： 未提交 1： 已认证 2： 审核中 -1：审核失败
      return 0 < this.mg_identificationStatus;
    },

    _c_isUsernameAndPassportNoReady() {
      return this.c_inputReadOnly || '' === this.username || '' === this.passportNo;
    },

    c_isIdentifyDisabled() {
      if (this.isForeigner) {
        return (
          this._c_isUsernameAndPassportNoReady || this.isPassportNofile || this.isPassportTooLarge
        );
      } else {
        return this._c_isUsernameAndPassportNoReady;
      }
    },
  },

  methods: {
    ...mapActions({
      ma_getUserInfo: 'getUserInfo',
    }),

    ...mapActions('Identity', {
      //ma_certificate: 'certificate',
      ma_identificationconfig: 'identificationconfig',
      ma_passportsubmit: 'passportsubmit',
      ma_idcheckandsave: 'idcheckandsave',
      //ma_idrefuse: 'idrefuse',
      //ma_idrecall: 'idrecall',
    }),

    //_testTxtInvalid(k) {
    //  let flagInvalid = false;
    //  if (!this[k]) {
    //    flagInvalid = true;
    //  }
    //  return flagInvalid;
    //},

    //handleTxtChange(k) {
    //  this.flagInvalid[k] = this._testTxtInvalid(k);
    //  this.setIsIdentifyReady(k);
    //},

    handleClickPassportBtn() {
      //$('#passport').trigger('click');
      this.$refs.passport.click();
    },

    //_testPassportInvalid() {
    //  let flagInvalid = false;
    //  let isPassportNofile = false;
    //  let isPassportTooLarge = false;
    //
    //  isPassportNofile = this.$refs.passport.files.length === 0;
    //  if (isPassportNofile) {
    //    flagInvalid = true;
    //  } else {
    //    const file = this.$refs.passport.files[0];
    //    isPassportTooLarge = file.size > 5 * 1024 * 1024;
    //    if (isPassportTooLarge) {
    //      flagInvalid = true;
    //    }
    //  }
    //  return {
    //    flagInvalid,
    //    isPassportNofile,
    //    isPassportTooLarge,
    //  };
    //},

    _readPassport(file) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => {
        this.passportSrc = e.target.result;
      };
    },

    handleChangePassport() {
      this.isPassportNofile = false;
      this.isShowPassportNofile = false;
      this.isPassportTooLarge = false;
      const file = this.$refs.passport.files[0];
      if (file) {
        this._readPassport(file);
        if (file.size > 5 * 1024 * 1024) {
          this.isPassportTooLarge = true;
          this.passportSrc = PassportImg;
        }
      }
    },

    //setIsIdentifyReady(k) {
    //  let flag = true;
    //  const usernameValid = !('username' === k
    //    ? this.flagInvalid.username
    //    : this._testTxtInvalid('username'));
    //  flag = flag && usernameValid;
    //  const passportNoValid = !('passportNo' === k
    //    ? this.flagInvalid.passportNo
    //    : this._testTxtInvalid('passportNo'));
    //  flag = flag && passportNoValid;
    //  const fileValid = !('file' === k
    //    ? this.flagInvalid.file
    //    : this._testPassportInvalid().flagInvalid);
    //  flag = flag && fileValid;
    //  this.isIdentifyReady = flag;
    //},

    async _afterSubmit() {
      if (this.ms_res_idcheckandsave.checkResult) {
        await swalSuccess(this.ms_res_idcheckandsave.checkMessage);
        this.goBack();
      } else {
        Swal.fire({
          title: this.ms_res_idcheckandsave.checkMessage,
          type: 'warning',
        });
      }
    },

    async passportsubmit() {
      const formData = new FormData();
      formData.append('username', this.username);
      formData.append('passportNo', this.passportNo);
      formData.append('file', this.$refs.passport.files[0]);
      await this.ma_passportsubmit(formData);
      this._afterSubmit();
    },

    goBack() {
      if (this.$route.query.identity_redirect_uri) {
        this.$router.push(this.$route.query.identity_redirect_uri);
      } else {
        this.$router.go(-1);
      }
    },

    async idcheckandsave() {
      await this.ma_idcheckandsave({
        realName: this.username,
        cardNo: this.passportNo,
      });
      this._afterSubmit();
    },

    submit() {
      if (this.isForeigner) {
        this.passportsubmit();
      } else {
        this.idcheckandsave();
      }
    },

    toggleIsForeigner() {
      this.isForeigner = !this.isForeigner;
    },

    //async idrefuse() {
    //  Swal.fire({
    //    title: '确定要拒绝审核吗？',
    //    text: '拒绝审核将无法重读',
    //    type: 'warning',
    //    showCancelButton: true,
    //    confirmButtonText: '确定拒绝',
    //    cancelButtonText: '我再想想',
    //  }).then(async (result) => {
    //    if (result.value) {
    //      await this.ma_idrefuse();
    //      await swalSuccess(this.ms_res_idrefuse.checkMessage);
    //      this.goBack();
    //    }
    //  });
    //},

    //async idrecall() {
    //  Swal.fire({
    //    title: '确定要撤回审核吗？',
    //    text: '撤回审核将无法重读',
    //    type: 'warning',
    //    showCancelButton: true,
    //    confirmButtonText: '确定撤回',
    //    cancelButtonText: '我再想想',
    //  }).then(async (result) => {
    //    if (result.value) {
    //      await this.ma_idrecall();
    //      await swalSuccess(this.ms_res_idrecall.checkMessage);
    //      this.goBack();
    //    }
    //  });
    //},

    async _IdentityCreated() {
      this.ma_identificationconfig();
      await this.ma_getUserInfo();
      this.username = this.mg_userInfo.username;
      this.passportNo = this.mg_userInfo.passportNo;
    },
  },

  created() {
    this._IdentityCreated();
  },
};
